import { Voucher } from '@src/core/buyerApiClient';
import { store, getClient, bearerAuth } from '@src/core/store';

export const getSaleVouchers = async (saleId: string) => {
  const state = store.getState();

  const {
    auth: { buyerToken },
  } = state;

  if (buyerToken == null) {
    return;
  }

  const { data: blob } = await getClient(state).vouchers.getSaleVouchersPdf(saleId, {
    ...bearerAuth(buyerToken),
    responseType: 'blob',
  });

  return blob;
};

export const getOrderVouchers = async (orderId: string) => {
  const state = store.getState();

  const {
    auth: { buyerToken },
  } = state;

  if (buyerToken == null) {
    return;
  }

  const { data: blob } = await getClient(state).vouchers.getOrderVouchersPdf(orderId, {
    ...bearerAuth(buyerToken),
    responseType: 'blob',
  });

  return blob;
};

export const getVoucher = async (voucher: Voucher) => {
  const state = store.getState();

  const {
    auth: { buyerToken },
  } = state;

  if (buyerToken == null) {
    return;
  }

  const { data: blob } = await getClient(state).vouchers.getVoucherPdf(voucher.id, {
    ...bearerAuth(buyerToken),
    responseType: 'blob',
  });

  return blob;
};
